import { render, staticRenderFns } from "./FileConfigWizard.vue?vue&type=template&id=438f6782&scoped=true"
import script from "./FileConfigWizard.vue?vue&type=script&lang=js"
export * from "./FileConfigWizard.vue?vue&type=script&lang=js"
import style0 from "./FileConfigWizard.vue?vue&type=style&index=0&id=438f6782&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438f6782",
  null
  
)

export default component.exports